import axios from "axios";
import router from "./index";

/**
 * Instância axios para o backend Node.js (porta 3001).
 * Todas as chamadas usam o prefixo /api/v2 que é
 * redirecionado pelo proxy do vue.config.js.
 */
const axiosV2 = axios.create({
  baseURL: "/api/v2",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Interceptor de request: adiciona token JWT
axiosV2.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && token !== "0") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Interceptor de response: trata 401 com refresh
axiosV2.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const originalRequest = error.config;

    if (status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers = originalRequest.headers || {};
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axiosV2(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const response = await axios.post("/api/v2/asas/usuario/refresh", {}, {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            },
            withCredentials: true
        });

        const { token } = response.data;

        if (!token) {
          throw new Error("Token não retornado pelo endpoint de refresh");
        }

        localStorage.setItem("token", token);
        axiosV2.defaults.headers.common["Authorization"] = "Bearer " + token;

        console.log("[requestV2] Token renovado com sucesso");

        processQueue(null, token);

        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers["Authorization"] = "Bearer " + token;
        return axiosV2(originalRequest);
      } catch (refreshError) {
        console.warn("[requestV2] Token expirado ou inválido, redirecionando para login.");
        processQueue(refreshError, null);
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        if (router.currentRoute.path !== "/" && router.currentRoute.path !== "/login") {
          router.push("/").catch(() => {});
        }

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

const requestV2 = {
  get: (url, config) => axiosV2.get(url, config),
  post: (url, data, config) => axiosV2.post(url, data, config),
  put: (url, data, config) => axiosV2.put(url, data, config),
  delete: (url, config) => axiosV2.delete(url, config),
};

export default requestV2;
